export default "__VITE_ASSET__GMCI6DWD__"